import HttpService from "./http-service";
import { WithTimestamps } from "@/typing";
import { Paginated } from "@/pagination";
import AsyncPaginatedRequest from "./async-paginated-request";
export default class EntityDocumentationSettingsService extends HttpService {
  public async getStatisticRecurrenceSettings(): Promise<
    StatisticRecurrenceTypeDTO[]
  > {
    const { data } = await this.httpClient.get<StatisticRecurrenceTypeDTO[]>(
      "statistic-recurrences"
    );
    return data;
  }

  public async setStatisticSubmissionRecurrence(
    year: number,
    recurrenceId: number,
    entityDocumentationId: number
  ): Promise<void> {
    return this.httpClient.post("statistic-submission-recurrences", {
      year,
      statistic_recurrence_id: recurrenceId,
      entity_documentation_id: entityDocumentationId,
    });
  }

  public getStatistcSubmissionRecurrences(
    entityDocumentationId: number
  ): AsyncIterator<Paginated<StatisticSubmissionRecurrenceDTO>> {
    const req = new AsyncPaginatedRequest<StatisticSubmissionRecurrenceDTO>(
      "get",
      "statistic-submission-recurrences",
      {
        entity_documentation_id: entityDocumentationId,
      },
      undefined,
      this.httpClient
    );
    return req.asyncIter();
  }

  public updateStatisticsSubmissionRecurrences(
      year: number,
      recurrenceId: number,
      entityDocumentationId: number,
      currentId:number
  ):Promise<void>
  {
    return this.httpClient.put(`statistic-submission-recurrences/${currentId}`, {
      year,
      statistic_recurrence_id: recurrenceId,
      entity_documentation_id: entityDocumentationId,
    });
  }
}

export interface StatisticRecurrenceTypeDTO extends WithTimestamps {
  id: number;
  name: string;
  months_frequency: number;
}

export interface StatisticSubmissionRecurrenceDTO {
  year: number;
  entity_documentation_id: number;
  statistic_recurrence_id: number;
}
